import type { Destination, RecordedEvent } from "./types";

/** A destination that keeps events in memory. For package tests, E2E and Storybook. */
export function recordingDestination(): Destination & { readonly events: readonly RecordedEvent[] } {
  const events: RecordedEvent[] = [];
  let userId: string | null = null;
  return {
    events,
    init: () => Promise.resolve(),
    track: (event) => {
      events.push({ ...event, userId });
    },
    identify: (user) => {
      userId = user?.userId ?? null;
    },
  };
}
